import { useRef } from 'react'
import { NotReady } from '@components'
import { useVideo } from '@front/model'
import { type WithVideoId } from '@terros/common'
import { useRequiredParams } from '@util'
import HlsPlayer from '../short.reports_.$videoId/HlsPlayer'
import { createFileRoute } from '@tanstack/react-router'
import { validateShortSearch } from './search'
import { useWatchProgress } from './useWatchProgress'

function Shorts(): JSX.Element {
  const { videoId } = useRequiredParams<WithVideoId>()
  const { taskId } = Route.useSearch()
  const playerRef = useRef<HTMLVideoElement>(null)
  const { onTimeUpdate, onSeeking, onEnded } = useWatchProgress({ videoId, taskId })

  const { data, isLoading, error } = useVideo(videoId)

  if (isLoading || error || !data) return <NotReady data={data} error={error} isLoading={isLoading} />
  const { video } = data

  return (
    <div className='relative'>
      <HlsPlayer
        autoPlay
        onEnded={onEnded}
        onTimeUpdate={onTimeUpdate}
        onSeeking={onSeeking}
        playsInline
        controls
        className='relative aspect-video max-h-full w-full object-contain'
        manifest={video.playlistUrl}
        poster={video.thumbnailUrl}
        style={{ aspectRatio: 9 / 16, flex: 1 }}
        ref={playerRef}
      />
      <div
        onClick={() => {
          if (playerRef.current?.paused) {
            playerRef.current?.play()
          } else {
            playerRef.current?.pause()
          }
        }}
        className='absolute bottom-0 left-0 right-0 top-0 flex flex-col justify-end bg-gradient-to-t from-gray-800/50 to-transparent p-4 text-white'
      >
        {video.description}
      </div>
    </div>
  )
}

export const Route = createFileRoute('/short_/$videoId/')({
  component: Shorts,
  validateSearch: validateShortSearch,
})
